import { useContext, useEffect } from "react";
import { useMap } from "react-map-gl/maplibre";

import { TenantContext } from "@nens/ranalib";
import { createMapLibreTransformFunction } from "@nens/react-map-gl/utils";

// Hook to update the map's transformRequest function with the new token if there is one

export function useMapTransformRequest() {
  const { authorizationHeader } = useContext(TenantContext);
  const map = useMap().current;

  useEffect(() => {
    if (!map || !authorizationHeader) return;

    // Update the token in the transformRequest function
    // Send 'isBearertoken false' because if we are using OAuth, Bearer
    // is already included. If we are using public publication auth, the
    // authorisation token uses Basic auth.
    map.setTransformRequest(createMapLibreTransformFunction(authorizationHeader, false));
  }, [map, authorizationHeader]);

  return null;
}
